if (typeof rcm != 'undefined') {
    // RCM is undefined in unit tests
    rcm.addAngularModule('pipe-rat-js');
}
angular.module('pipe-rat-js', ['RcmLoading', 'RcmJsLib', 'rcmApiLib']);

/**
 * @deprecated Use PipeRatApiRepositoryPromise
 * PipeRatApiRepository
 * @param rcmApiLibService
 * @param rcmLoading
 * @param rcmEventManager
 * @param basePath
 * @param namespace
 * @constructor
 */
var PipeRatApiRepository = function (
    rcmApiLibService,
    rcmLoading,
    rcmEventManager,
    basePath,
    namespace
) {
    var self = this;

    self.basePath = basePath;

    self.namespace = namespace;

    /**
     * onLoading
     * @param loading
     * @param method
     */
    var onLoading = function (loading, method) {
        var loadingInt = Number(!loading);
        rcmLoading.setLoading(
            self.namespace + '.' + method + '.loading',
            loadingInt
        );
        rcmEventManager.trigger(
            self.namespace + '.loading',
            loading
        );
    };

    /**
     *
     * @param response
     * @param status
     * @param success
     * @param method
     */
    var onApiSuccess = function (response, status, success, method) {
        rcmEventManager.trigger(
            self.namespace + '.' + method + '.success',
            response
        );
        if (typeof success === 'function') {
            success(response, status);
        }
    };

    /**
     *
     * @param response
     * @param status
     * @param error
     * @param method
     */
    var onApiError = function (response, status, error, method) {
        rcmEventManager.trigger(
            self.namespace + '.' + method + '.error',
            {
                response: response,
                status: status,
            }
        );
        if (typeof error === 'function') {
            error(response, status);
        }
    };

    /**
     * @param id
     * @param method
     */
    var assertId = function (id, method) {
        if (!id) {
            throw new Error('Id is required for ' + method + ' by ID for: ' + self.namespace);
        }
    };

    /**
     * getEventManager
     * @returns {rcmEventManager|*}
     */
    self.getEventManager = function () {
        return rcmEventManager;
    };

    /**
     * getEventManager
     * @returns {rcmLoading|*}
     */
    self.getLoading = function () {
        return rcmLoading;
    };

    /**
     * getApiService
     * @returns {rcmApiLibService|*}
     */
    self.getApiService = function () {
        return rcmApiLibService;
    };

    /**
     * @param id
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.findById = function (id, success, error, params) {

        var method = 'findById';

        assertId(id, method);

        return rcmApiLibService.get(
            {
                url: self.basePath + '/{id}',
                urlParams: {id: id},
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * create
     * @param data
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.create = function (data, success, error, params) {

        var method = 'create';

        return rcmApiLibService.post(
            {
                url: self.basePath,
                data: data,
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * upsert
     * @param data
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.upsert = function (data, success, error, params) {

        var method = 'upsert';

        return rcmApiLibService.put(
            {
                url: self.basePath,
                data: data,
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * exists
     * @param id
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.exists = function (id, success, error, params) {

        var method = 'exists';

        assertId(id, method);

        return rcmApiLibService.get(
            {
                url: self.basePath + '/{id}/exists',
                urlParams: {id: id},
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * count
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.count = function (success, error, params) {

        var method = 'count';

        return rcmApiLibService.get(
            {
                url: self.basePath + '/count',
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * findOne
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.findOne = function (success, error, params) {

        var method = 'findOne';

        return rcmApiLibService.get(
            {
                url: self.basePath + '/findOne',
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * find
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.find = function (success, error, params) {

        var method = 'find';

        return rcmApiLibService.get(
            {
                url: self.basePath,
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * deleteById
     * @param id
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.deleteById = function (id, success, error, params) {

        var method = 'deleteById';

        assertId(id, method);

        return rcmApiLibService.del(
            {
                url: self.basePath + '/{id}',
                urlParams: {id: id},
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * updateProperties
     * @param id
     * @param data
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.updateProperties = function (id, data, success, error, params) {

        var method = 'updateProperties';

        assertId(id, method);

        return rcmApiLibService.put(
            {
                url: self.basePath + '/{id}',
                urlParams: {id: id},
                data: data,
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
                success: function (response, status) {
                    onApiSuccess(response, status, success, method);
                },
                error: function (response, status) {
                    onApiError(response, status, error, method);
                },
            }
        );
    };

    /**
     * findPage
     * @param recordCount
     * @param recordsPerPage
     * @param pageNumber
     * @param success
     * @param error
     * @param params
     * @returns {Promise}
     */
    self.findPage = function (
        recordCount,
        recordsPerPage,
        pageNumber,
        success,
        error,
        params
    ) {
        var method = 'findPage';

        var totalPages = Math.ceil(recordCount / recordsPerPage);

        if (pageNumber > totalPages || pageNumber < 0) {
            var message = new rcmApiLibService.ApiMessage();
            message.value = 'Page ' + pageNumber + ' is out of range';
            message.primary = true;
            var response = {
                messages: [
                    message,
                ],
            };
            onApiError(response, 400, error, method);
            return;
        }

        var skip = pageNumber * recordsPerPage;

        if (!params) {
            params = {};
        }

        params['filter[limit]'] = recordsPerPage;
        params['filter[skip]'] = skip;

        return self.find(
            success,
            function (response, status) {
                onApiSuccess(response, status, success, method);
            },
            function (response, status) {
                onApiError(response, status, error, method);
            }
        );
    };

    /**
     * init
     */
    var init = function () {
        if (!basePath) {
            throw console.error('basePath is required');
        }
        if (!self.namespace) {
            self.namespace = '_DEFAULT';
        }
    };

    init();
};

/**
 * @deprecated Use pipeRatApiRepositoryPromiseService
 * pipeRatApiRepositoryService {pipeRatApiRepositoryService}
 */
angular.module('pipe-rat-js').service(
    'pipeRatApiRepositoryService',
    [
        'rcmApiLibService',
        'rcmLoading',
        'rcmEventManager',
        function (
            rcmApiLibService,
            rcmLoading,
            rcmEventManager
        ) {
            var self = this;

            /**
             * getNewRepository
             * @param {string} basePath
             * @param {string} namespace
             * @returns {PipeRatApiRepository}
             */
            self.getNewRepository = function (
                basePath,
                namespace
            ) {
                return new PipeRatApiRepository(
                    rcmApiLibService,
                    rcmLoading,
                    rcmEventManager,
                    basePath,
                    namespace
                );
            };
        },
    ]
);

/**
 * PipeRatApiRepositoryPromise
 * @param rcmApiLibService
 * @param rcmLoading
 * @param rcmEventManager
 * @param basePath
 * @param namespace
 * @constructor
 */
var PipeRatApiRepositoryPromise = function (
    rcmApiLibService,
    rcmLoading,
    rcmEventManager,
    basePath,
    namespace
) {
    var self = this;

    self.basePath = basePath;

    self.namespace = namespace;

    /**
     * onLoading
     * @param loading
     * @param method
     */
    var onLoading = function (loading, method) {
        var loadingInt = Number(!loading);
        rcmLoading.setLoading(
            self.namespace + '.' + method + '.loading',
            loadingInt
        );
        rcmEventManager.trigger(
            self.namespace + '.loading',
            loading
        );
    };

    /**
     *
     * @param response
     * @param status
     * @param method
     * @returns {Promise}
     */
    var onApiSuccess = function (response, status, method) {
        rcmEventManager.trigger(
            self.namespace + '.' + method + '.success',
            response
        );
        return new Promise(
            function (resolve, reject) {
                resolve(response, status);
            }
        );
    };

    /**
     *
     * @param response
     * @param status
     * @param method
     * @returns {Promise}
     */
    var onApiError = function (response, status, method) {
        rcmEventManager.trigger(
            self.namespace + '.' + method + '.error',
            {
                response: response,
                status: status,
            }
        );
        return new Promise(
            function (resolve, reject) {
                reject(response, status);
            }
        );
    };

    /**
     * @param id
     * @param method
     */
    var assertId = function (id, method) {
        if (!id) {
            throw new Error('Id is required for ' + method + ' by ID for: ' + self.namespace);
        }
    };

    /**
     * getEventManager
     * @returns {rcmEventManager|*}
     */
    self.getEventManager = function () {
        return rcmEventManager;
    };

    /**
     * getEventManager
     * @returns {rcmLoading|*}
     */
    self.getLoading = function () {
        return rcmLoading;
    };

    /**
     * getApiService
     * @returns {rcmApiLibService|*}
     */
    self.getApiService = function () {
        return rcmApiLibService;
    };

    /**
     * @param id
     * @param params
     * @returns {Promise}
     */
    self.findById = function (id, params) {

        var method = 'findById';

        assertId(id, method);

        return rcmApiLibService.get(
            {
                url: self.basePath + '/{id}',
                urlParams: {id: id},
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * create
     * @param data
     * @param params
     * @returns {Promise}
     */
    self.create = function (data, params) {

        var method = 'create';

        return rcmApiLibService.post(
            {
                url: self.basePath,
                data: data,
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * upsert
     * @param data
     * @param params
     * @returns {Promise}
     */
    self.upsert = function (data, params) {

        var method = 'upsert';

        return rcmApiLibService.put(
            {
                url: self.basePath,
                data: data,
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * exists
     * @param id
     * @param params
     * @returns {Promise}
     */
    self.exists = function (id, params) {

        var method = 'exists';

        assertId(id, method);

        return rcmApiLibService.get(
            {
                url: self.basePath + '/{id}/exists',
                urlParams: {id: id},
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * count
     * @param params
     * @returns {Promise}
     */
    self.count = function (params) {

        var method = 'count';

        return rcmApiLibService.get(
            {
                url: self.basePath + '/count',
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * findOne
     * @param params
     * @returns {Promise}
     */
    self.findOne = function (params) {

        var method = 'findOne';

        return rcmApiLibService.get(
            {
                url: self.basePath + '/findOne',
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * find
     * @param params
     * @returns {Promise}
     */
    self.find = function (params) {

        var method = 'find';

        return rcmApiLibService.get(
            {
                url: self.basePath,
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * deleteById
     * @param id
     * @param params
     * @returns {Promise}
     */
    self.deleteById = function (id, params) {

        var method = 'deleteById';

        assertId(id, method);

        return rcmApiLibService.del(
            {
                url: self.basePath + '/{id}',
                urlParams: {id: id},
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * updateProperties
     * @param id
     * @param data
     * @param params
     * @returns {Promise}
     */
    self.updateProperties = function (id, data, params) {

        var method = 'updateProperties';

        assertId(id, method);

        return rcmApiLibService.put(
            {
                url: self.basePath + '/{id}',
                urlParams: {id: id},
                data: data,
                params: params,
                loading: function (loading) {
                    onLoading(loading, method);
                },
            }
        ).then(
            function (response, status) {
                return onApiSuccess(response, status, method);
            }
        ).catch(
            function (response, status) {
                return onApiError(response, status, method);
            }
        );
    };

    /**
     * findPage
     * @param recordCount
     * @param recordsPerPage
     * @param pageNumber
     * @param params
     * @returns {Promise}
     */
    self.findPage = function (
        recordCount,
        recordsPerPage,
        pageNumber,
        params
    ) {
        var method = 'findPage';

        var totalPages = Math.ceil(recordCount / recordsPerPage);

        if (pageNumber > totalPages || pageNumber < 0) {
            var message = new rcmApiLibService.ApiMessage();
            message.value = 'Page ' + pageNumber + ' is out of range';
            message.primary = true;
            var response = {
                messages: [
                    message,
                ],
            };
            return onApiError(response, 400, method);
        }

        var skip = pageNumber * recordsPerPage;

        if (!params) {
            params = {};
        }

        params['filter[limit]'] = recordsPerPage;
        params['filter[skip]'] = skip;

        return self.find(
            params
        );
    };

    /**
     * init
     */
    var init = function () {
        if (!basePath) {
            throw console.error('basePath is required');
        }
        if (!self.namespace) {
            self.namespace = '_DEFAULT';
        }
    };

    init();
};

/**
 * pipeRatApiRepositoryPromiseService {PipeRatApiRepositoryPromise}
 */
angular.module('pipe-rat-js').service(
    'pipeRatApiRepositoryPromiseService',
    [
        'rcmApiLibService',
        'rcmLoading',
        'rcmEventManager',
        function (
            rcmApiLibService,
            rcmLoading,
            rcmEventManager
        ) {
            var self = this;

            /**
             * getNewRepository
             * @param {string} basePath
             * @param {string} namespace
             * @returns {PipeRatApiRepositoryPromise}
             */
            self.getNewRepository = function (
                basePath,
                namespace
            ) {
                return new PipeRatApiRepositoryPromise(
                    rcmApiLibService,
                    rcmLoading,
                    rcmEventManager,
                    basePath,
                    namespace
                );
            };
        },
    ]
);
